module.exports = __webpack_public_path__ + "img/seminar (12).29cbfa78.jpg";